module.exports = __webpack_public_path__ + "img/kairoScreen.png";